import * as types from '../mutation-types';
import AiAuditsAPI from '../../api/aiAudits';

const state = {
  // keyed by conversation_id
  records: {},
  uiFlags: {},
};

const getters = {
  getAuditByConversation: _state => conversationId => _state.records[conversationId],
  getUiFlags: _state => conversationId =>
    _state.uiFlags[conversationId] || { loading: false, triggering: false, error: null },
};

const actions = {
  async fetch({ commit, rootGetters }, conversationId) {
    const accountId = rootGetters.getCurrentAccountId;
    commit(types.default.SET_AI_AUDIT_UI_FLAG, { conversationId, loading: true, error: null });
    try {
      const { data } = await AiAuditsAPI.get(accountId, conversationId);
      commit(types.default.SET_AI_AUDIT, { conversationId, data });
    } catch (error) {
      const status = error?.response?.status;
      if (status !== 404) {
        commit(types.default.SET_AI_AUDIT_UI_FLAG, {
          conversationId,
          error: 'Erro ao carregar auditoria.',
        });
      }
    } finally {
      commit(types.default.SET_AI_AUDIT_UI_FLAG, { conversationId, loading: false });
    }
  },

  clear({ commit }, conversationId) {
    commit(types.default.SET_AI_AUDIT, { conversationId, data: null });
  },

  async validate({ commit, rootGetters }, conversationId) {
    const accountId = rootGetters.getCurrentAccountId;
    commit(types.default.SET_AI_AUDIT_UI_FLAG, { conversationId, validating: true });
    try {
      const { data } = await AiAuditsAPI.validate(accountId, conversationId);
      commit(types.default.VALIDATE_AI_AUDIT, { conversationId, validated_at: data.validated_at, validated_by: data.validated_by });
    } catch {
      commit(types.default.SET_AI_AUDIT_UI_FLAG, { conversationId, error: 'Erro ao validar.' });
    } finally {
      commit(types.default.SET_AI_AUDIT_UI_FLAG, { conversationId, validating: false });
    }
  },

  async trigger({ commit, rootGetters }, conversationId) {
    const accountId = rootGetters.getCurrentAccountId;
    commit(types.default.SET_AI_AUDIT_UI_FLAG, { conversationId, triggering: true, error: null });
    try {
      await AiAuditsAPI.create(accountId, conversationId);
    } catch {
      commit(types.default.SET_AI_AUDIT_UI_FLAG, {
        conversationId,
        error: 'Falha ao disparar auditoria.',
      });
    } finally {
      commit(types.default.SET_AI_AUDIT_UI_FLAG, { conversationId, triggering: false });
    }
  },
};

const mutations = {
  [types.default.SET_AI_AUDIT_UI_FLAG](_state, { conversationId, ...flags }) {
    _state.uiFlags = {
      ..._state.uiFlags,
      [conversationId]: { ...(_state.uiFlags[conversationId] || {}), ...flags },
    };
  },
  [types.default.SET_AI_AUDIT](_state, { conversationId, data }) {
    _state.records = { ..._state.records, [conversationId]: data };
  },
  [types.default.VALIDATE_AI_AUDIT](_state, { conversationId, validated_at, validated_by }) {
    if (!_state.records[conversationId]) return;
    _state.records = {
      ..._state.records,
      [conversationId]: { ..._state.records[conversationId], validated_at, validated_by },
    };
  },
};

export default { namespaced: true, state, getters, actions, mutations };
